"use client"
import { VALUE_PROP_COLORS, VALUE_PROP_ICONS } from "@/data/value-props"

interface ValuePropCardsProps {
  /** Labels for the 4 cards (in display order). Already translated. */
  labels: string[]
  className?: string
}

/**
 * 4-up row of colored value-prop cards with icons — used on the homepage
 * and all /go/* landing pages as the trust-feature row. Colors and icons
 * come from `data/value-props.tsx`; pass in already-translated `labels`.
 */
export function ValuePropCards({
  labels,
  className = "",
}: ValuePropCardsProps) {
  return (
    <section className={`py-4 md:py-12 ${className}`}>
      <div className="mx-auto grid max-w-[1440px] grid-cols-2 gap-4 px-4 md:grid-cols-4 md:px-10">
        {labels.map((label, index) => {
          const Icon = VALUE_PROP_ICONS[index % VALUE_PROP_ICONS.length]
          return (
            <div key={`${label}-${index}`}>
              <div
                className="flex h-full min-h-[180px] flex-col items-center justify-center gap-[15px] rounded-lg px-4 py-4 text-center md:min-h-[160px] md:px-6"
                style={{
                  backgroundColor:
                    VALUE_PROP_COLORS[index % VALUE_PROP_COLORS.length],
                }}
              >
                <div className="p-1">
                  <Icon />
                </div>
                {/* `w-full` is load-bearing (AHD-10495): the span is a flex
                    item of an `items-center` column, so without an explicit
                    width it sizes to fit-content — which floors at
                    min-content, i.e. the longest word. In the 2-col mobile
                    grid the card's content box is ~108px, so a German
                    compound like "Momentaufnahme" (154px) blew the span past
                    both card edges into the neighbouring card. `w-full` caps
                    it at the card, and `break-words` gives the word a
                    last-resort break for the compounds the German
                    soft-hyphen lexicon doesn't reach (< its 15-char
                    threshold). */}
                <span
                  className="type-title-md mx-auto block w-full max-w-[200px] break-words text-black/[0.99]"
                  style={{ fontSize: 18 }}
                >
                  {label}
                </span>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}
